export enum VideoMapping {
    Normal,
    OneEighty,
    ThreeSixty
}